// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import qs from 'qs'
import 'font-awesome/css/font-awesome.min.css'
import store from './store'
import cnLocale from './assets/i18n/cn'
import enLocale from './assets/i18n/en'
import elEnLocale from 'element-ui/lib/locale/lang/en'
import elCnLocale from 'element-ui/lib/locale/lang/zh-CN'
import * as dd from 'dingtalk-jsapi'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VueClipboard from 'vue-clipboard2'
import request from '@/assets/js/axios/request'

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$dd = dd
Vue.prototype.$npg = NProgress

Vue.prototype.$request = request

// Use runtime configuration if available, otherwise fallback to build-time config
Vue.prototype.api = (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX) || process.env.API_PREFIX || ''
Vue.prototype.api2 = (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX_2) || process.env.API_PREFIX_2 || ''

axios.defaults.baseURL = '/'
axios.defaults.headers = {
  'Content-Type': 'application/json;charset=UTF-8',
}
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(VueClipboard)

const i18n = new VueI18n({
  locale: 'en',
  silentFallbackWarn: true,
  messages: {
    cn: {
      ...cnLocale,
      ...elCnLocale,
    },
    en: {
      ...enLocale,
      ...elEnLocale,
    },
  },
})

NProgress.configure({
  easing: 'speed',
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.1,
})

Vue.use(ElementUi, {
  i18n: (key, value) => i18n.t(key, value),
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App,
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js